import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { IconButton, InputAdornment, TextField, TextFieldProps } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

interface SearchFieldProps extends Omit<TextFieldProps, 'onChange' | 'value' | 'placeholder' | 'variant'> {
  value?: string;
  placeholder?: string;
  variant?: 'normal' | 'search';

  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;

  onClear?: () => void;
}

const PaiRoundTextField: React.FC<SearchFieldProps> = ({ value, placeholder, variant = 'normal', onChange, onClear, ...props }) => {
  const { classes } = useStyles();

  return (
    <TextField
      {...props}
      className={classes.textfield}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      variant={'outlined'}
      size={'small'}
      InputProps={{
        classes: { input: classes.input },
        endAdornment:
          variant === 'search' ? (
            <InputAdornment position={'end'}>
              {value ? (
                <IconButton size={'small'} onClick={onClear}>
                  <ClearIcon className={classes.icon} />
                </IconButton>
              ) : (
                <SearchIcon className={classes.icon} />
              )}
            </InputAdornment>
          ) : undefined,
      }}
    />
  );
};

const useStyles = makeStyles()((theme) => ({
  textfield: {
    background: '#FFF',
    borderRadius: '16px',
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& .MuiInputBase-root': {
      border: `1px solid ${theme.palette.greys.light}`,
      borderRadius: '16px',
      '&.Mui-focused': {
        border: `1px solid ${theme.palette.primary.main}`,
      },
      '&:hover': {
        border: `1px solid ${theme.palette.primary.main}`,
      },
    },
  },
  input: {
    fontSize: theme.typography.pxToRem(15),
    padding: '4px 0 4px 16px',
    borderTopLeftRadius: '16px',
    borderBottomLeftRadius: '16px',
    height: 'calc(30px - 8px)',
    '& .Mui-disabled': {
      color: theme.palette.greys.light,
    },
    '&::placeholder': {
      opacity: 0.5,
      fontSize: theme.typography.pxToRem(15),
    },
    '&:focus': {
      '&::placeholder': {
        opacity: 0,
      },
    },
  },
  icon: {
    fontSize: theme.typography.pxToRem(20),
  },
}));

export default PaiRoundTextField;
